import { createAction, props } from '@ngrx/store';
import { IUserData, SupportedWallets } from './auth.state';

export const authenticatedAction = createAction(
    '[AngularFireAuth] Authenticated',
    props<{
        userData: IUserData;
    }>()
);

export const notAuthenticatedAction = createAction(
    '[AngularFireAuth] Not Authenticated',
    (isAuthenticatedPreviously?: boolean) => ({
        isAuthenticatedPreviously,
    })
);

export const loginWithEmailAction = createAction(
    '[AngularFireAuth] Email Login Attempt',
    (email: string, password: string, hasWeakPassword: boolean) => ({
        email,
        password,
        hasWeakPassword
    })
)

export const loginWithFacebookAction = createAction(
    '[AngularFireAuth] Login With Facebook Attempt',
    (inviteCode: string | null) => ({
        inviteCode,
    })
)

export const loginWithGoogleAction = createAction(
    '[AngularFireAuth] Login With Google Attempt',
    (inviteCode: string | null) => ({
        inviteCode,
    })
)

export const loginWithWalletAction = createAction(
    '[AngularFireAuth] Login With Wallet Attempt',
    (inviteCode: string | null, wallet: SupportedWallets ) => ({
        inviteCode,
        wallet
    })
)

export const loginWithAppleAction = createAction(
    '[AngularFireAuth] Login With Apple Attempt',
    (inviteCode: string | null) => ({
        inviteCode,
    })
)

export const loginAsGuestAction = createAction(
    '[AngularFireAuth] Login As Guest Attempt',
)

export const loginSuccessAction = createAction(
    '[AngularFireAuth] Login Success',
)

export const loginFailedAction = createAction(
    '[AngularFireAuth] Login Failed',
    (error: any) => ({
        error,
    })
)

export const resetPasswordAction = createAction(
    '[AngularFireAuth] Reset Password Attempt',
    (email: string) => ({
        email,
    })
)

export const resetPasswordSuccessAction = createAction(
    '[AngularFireAuth] Reset Password Success',
)

export const resetPasswordFailedAction = createAction(
    '[AngularFireAuth] Reset Password Error',
    (error: any) => ({
        error,
    })
)

export const signupAction = createAction(
    '[AngularFireAuth] Signup Attempt',
    (email: string, password: string, inviteCode: string | null) => ({
        email,
        password,
        inviteCode,
    })
)

export const signupSuccessAction = createAction(
    '[AngularFireAuth] Signup Success',
)

export const signupErrorAction = createAction(
    '[AngularFireAuth] Signup Error',
    (error: any) => ({
        error,
    })
)

export const logoutAction = createAction(
    '[AngularFireAuth] Logout',
    props<{
        isDelete: Readonly<boolean>;
        inviteCode: string;
        logInOnOtherDevice: boolean;
    }>()
)

export const authErrorAction = createAction(
    '[AngularFireAuth] Authentication Error',
    (error: any) => ({
        error,
    })
)

export const nonAnonymousLogin = createAction(
    '[AngularFireAuth] Non Anonymous Login',
)

export const setWeakPasswordAction = createAction(
    '[AngularFireAuth] Set Weak Password',
    props<{
        isWeak: boolean,
    }>()
)

export const setIsRegistrationAction = createAction(
    '[AngularFireAuth] Set Is Registration',
    props<{
        isRegistration: boolean | null,
    }>()
)
